import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';
import EmptyList from '@/shared/components/molecules/ChooseAsset/EmptyList';
import ListItem from '@/shared/components/molecules/ChooseAsset/ListItem';

interface ListProps {
  list: AssetItemProps[];
  activeKey: number;
  selectedAsset?: AssetItemProps;
  setselectedAsset: (val: AssetItemProps) => void;
}

const List: React.FC<ListProps> = ({
  list,
  activeKey,
  selectedAsset,
  setselectedAsset,
}) => {
  return (
    <div className='flex w-full flex-col justify-between'>
      {list.length ? (
        <>
          <div className='flex w-full flex-col gap-16'>
            {list?.map((item) => (
              <ListItem
                key={item.id}
                active={item.id === selectedAsset?.id}
                data={item}
                onClick={() => setselectedAsset(item)}
              />
            ))}
          </div>
        </>
      ) : (
        <EmptyList type={activeKey === 2 ? 'farm' : 'packhouse'} />
      )}
    </div>
  );
};

export default List;
